"use client"

import clsx from "clsx"

import type { PropsWithClassName } from "~/@types/generics"
import InlineCta from "~/components/ui/InlineCta"
import type { IconProps } from "~/components/abstracts/Icon"
import { showZendeskWidget, useToggleActivateZendesk } from "~/components/globals/ZendeskChat"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"

import * as css from "./styles.css"

type ChatButtonProps = PropsWithClassName<{}>

export function ChatButton({ className }: ChatButtonProps) {
  const [zendeskTriggeredOnce, toggleZendeskActive] = useToggleActivateZendesk()

  const t = useTranslate()
  const iconProps = {
    name: "Chat",
    direction: "right",
    theme: "black",
  } satisfies IconProps

  return (
    <InlineCta
      className={clsx(css.chatCta, className)}
      size="small"
      onClick={() => {
        zendeskTriggeredOnce ? showZendeskWidget() : toggleZendeskActive(true)
      }}
      color="black"
      icon={iconProps}
      withLine
    >
      {t("chat_button_text")}
    </InlineCta>
  )
}
